import React, { useEffect, useState, useCallback } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import styles from './teamPage.module.css'
import Header from "../header/header";
import { supabase } from "../../utils/supabaseClient";

const teamMenu = [
    { name: 'Squad', link: 'squad' },
    { name: 'Staff', link: 'staff' },
    { name: 'Matches', link: 'matches' }
]

interface TeamShort {
    team_id: number
    team_club_id: number
    team_club_short_name: string
    team_club_logo: string
    team_club_city: string
    team_club_country: string
}

const TeamPage: React.FC = () => {
    const { id } = useParams<{ id: string }>()
    const [team, setTeam] = useState<TeamShort | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    const fetchTeamsShort = useCallback(async (): Promise<TeamShort | null> => {
        try {
            console.log('Fetching teams data...');

            if (!id) {
                throw new Error('Team ID is undefined');
            }

            const { data: teamsData, error: teamsError } = await supabase
                .from('teams_short')
                .select('*')
                .eq('team_id', id)
                .single();

            if (teamsError) {
                console.error('Team Error:', teamsError);
                throw teamsError;
            }

            return teamsData as TeamShort;
        } catch (error) {
            console.error('Error fetching teams:', error);
            throw error;
        }
    }, [id]);

    useEffect(() => {
        const loadTeam = async () => {
            try {
                setLoading(true);
                const teamData = await fetchTeamsShort();
                setTeam(teamData);
            } catch (error) {
                setError(error instanceof Error ? error.message : 'An unknown error occurred');
            } finally {
                setLoading(false);
            }
        };

        loadTeam();
    }, [fetchTeamsShort])

    const teamName = team ? team.team_club_short_name : 'Team'

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <>
            <Header title={teamName} menu={teamMenu}/>
            <main>
                <Outlet context={id}/>
            </main>
        </>
    )
}

export default TeamPage